import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <main className="min-h-screen bg-slate-950 px-4 py-16 text-white">
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="text-sm text-white/60 underline hover:text-white">&larr; Back to AnoteQuest</Link>
        <p className="mt-6 text-sm font-semibold uppercase tracking-wider text-amber-300">Legal</p>
        <h1 className="mt-3 text-4xl font-semibold">Terms and Conditions</h1>
        <p className="mt-2 text-sm text-white/50">Last updated: July 21, 2026</p>

        <div className="mt-10 space-y-8 text-white/85">
          <section>
            <h2 className="text-xl font-semibold text-white">1. Acceptance of terms</h2>
            <p className="mt-3 leading-7">
              By creating an account, signing in, or otherwise using AnoteQuest, you agree to these
              Terms and Conditions. If you do not agree, please do not use the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">2. The service</h2>
            <p className="mt-3 leading-7">
              AnoteQuest is a canvas-based notes and organization tool. It offers a free synced plan
              with limited storage, a local-only mode that keeps your data on your own device, and a
              paid plan with additional synced storage. We may change, add to, or remove features over
              time as the product evolves.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">3. Your account</h2>
            <p className="mt-3 leading-7">
              You are responsible for keeping your login credentials secure and for all activity that
              happens under your account. Let us know right away if you suspect unauthorized access.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">4. Your content</h2>
            <p className="mt-3 leading-7">
              You keep ownership of the notes, images, and other content you create in AnoteQuest. You
              are responsible for what you upload and must have the right to use it. Content saved in
              local-only mode is stored on your device and is not transmitted to our servers; content
              stored on a synced plan is kept on our infrastructure so it can sync across your devices.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">5. Subscriptions and billing</h2>
            <p className="mt-3 leading-7">
              Paid plans are billed through PayPal on a recurring basis until cancelled. You can manage
              or cancel your subscription at any time from your PayPal account. Fees already billed are
              generally non-refundable except where required by law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">6. Acceptable use</h2>
            <p className="mt-3 leading-7">
              Please don't use AnoteQuest to store or share unlawful content, attempt to disrupt the
              service, or access accounts or data that aren't yours.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">7. Service availability</h2>
            <p className="mt-3 leading-7">
              We aim to keep AnoteQuest reliable, but the service is provided "as is" without warranties
              of any kind, and we can't guarantee it will always be uninterrupted or error-free.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">8. Changes to these terms</h2>
            <p className="mt-3 leading-7">
              We may update these terms from time to time. Continuing to use AnoteQuest after an update
              means you accept the revised terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">9. Contact</h2>
            <p className="mt-3 leading-7">
              Questions about these terms? Reach out at{" "}
              <a href="mailto:support@anotequest.com" className="text-amber-300 underline hover:text-amber-200">
                support@anotequest.com
              </a>.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
